import Vue from "vue";
/**
 * @description 函数式使用一个组件
 * @param {import("vue").ComponentOptions} component 组件对象
 * @param {Object} data 默认的data
 * @param {Object} props 需要传入的props
 * @returns {Promise} 此组件通过resolve获取的数据
 */
export default (component, data = {}, propsData = {}) => {
  const Comp = Vue.extend(component);
  const store = require('../store/index.js').default;
  const router = require('../router/index.js').default();
  let instance;
  const pro = new Promise((resolve, reject) => {
    instance = new Comp({
      data: () => ({ ...data }),
      propsData,
      store,
      router,
      methods: { resolve, reject }
    });
    instance.$mount();
    document.body.appendChild(instance.$el);
    instance.$on('resolve', resolve);
    instance.$on('reject', reject);
    instance.$on('hook:beforeDestroy', () => {
      reject("close");
    });
    instance.$on('hook:destroyed', () => {
      instance.$el.parentNode?.removeChild(instance.$el);
    });
  });
  pro.finally(() => {
    instance.$destroy();
  });
  return pro;
};
/**
 * @type {import("vue").ComponentOptions}
 * @description 适配异步弹框组件的混合项
 */
export const asyncMixin = {
  methods: {
    resolve(...item) {
      this.$emit('resolve', ...item);
    },
    reject(...item) {
      this.$emit('reject', ...item);
    }
  }
};
